/** Shopify's CDN resizes on demand: drop any size suffix and request a width instead. */
export function shopifyImageUrl(url: string, width: number): string {
  const resized = new URL(url)
  resized.pathname = resized.pathname.replace(/_\d+x\d+(?=\.\w+$)/, '')
  resized.searchParams.set('width', String(width))
  return resized.toString()
}

/** The CDN never upscales, so widths are capped to the original's to keep descriptors truthful. */
export function shopifyImageSrcset(url: string, widths: number[], originalWidth = Infinity): string {
  const capped = widths.filter((width) => width < originalWidth)

  if (capped.length < widths.length) {
    capped.push(originalWidth)
  }

  return capped.map((width) => `${shopifyImageUrl(url, width)} ${width}w`).join(', ')
}
